var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgStar = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.92937 0.756229C8.10898 0.203442 8.89102 0.203444 9.07063 0.756231L10.4982 5.14975C10.5785 5.39696 10.8089 5.56434 11.0688 5.56434H15.6884C16.2697 5.56434 16.5113 6.30811 16.0411 6.64975L12.3037 9.36509C12.0935 9.51788 12.0055 9.7887 12.0858 10.0359L13.5133 14.4294C13.6929 14.9822 13.0602 15.4419 12.59 15.1003L8.85267 12.3849C8.64238 12.2321 8.35762 12.2321 8.14733 12.3849L4.40998 15.1003C3.93975 15.4419 3.30706 14.9822 3.48667 14.4294L4.91421 10.0359C4.99454 9.7887 4.90654 9.51788 4.69625 9.36509L0.958901 6.64975C0.488672 6.30811 0.730339 5.56434 1.31157 5.56434H5.93119C6.19113 5.56434 6.4215 5.39696 6.50183 5.14975L7.92937 0.756229Z",
    fill: "black"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/star.da537e1d.svg";
export { ForwardRef as ReactComponent };